module.exports = __webpack_public_path__ + "img/1_8_1.33a8c44b.jpg";